/** @jsxImportSource @emotion/react */
import ReactSelect from 'react-select'
import { toast } from 'react-toastify'

import { NeededDeviceType } from 'store/types'
import {
  useGetOfficeSettingsQuery,
  useUpdateOfficeSettingsMutation,
} from 'store/services/office'
import { OfficePreferredDmeOfficeSection } from './OfficePreferredDmeOfficeSection'
import { OfficeFollowUpProvidersSection } from './OfficeFollowUpProvidersSection'

interface IProps {
  officeId: number
}

const deviceTypeOptions = Object.entries(NeededDeviceType).map(([key, label]) => ({
  value: key,
  label,
}))

export const OfficePreferencesPanel = ({ officeId }: IProps) => {
  const { data: officeSettings } = useGetOfficeSettingsQuery({ id: officeId })
  const [updateOfficeSettings] = useUpdateOfficeSettingsMutation()

  const handleDeviceTypesChange = async (deviceTypes: NeededDeviceType[]) => {
    try {
      await updateOfficeSettings({
        id: officeId,
        preferredDeviceTypes: deviceTypes,
      }).unwrap()
    } catch (error) {
      console.error('Error updating office preferred device types:', error)
      toast.error('Failed to update preferred device types.')
    }
  }

  return (
    <div>
      <div className="form-group textGray">
        <label htmlFor="officePreferredDeviceTypes">Preferred Devices</label>
        <ReactSelect
          inputId="officePreferredDeviceTypes"
          isMulti
          menuPortalTarget={document.body}
          options={deviceTypeOptions}
          value={deviceTypeOptions.filter((option) =>
            officeSettings?.preferredDeviceTypes?.includes(option.value as NeededDeviceType),
          )}
          onChange={(selected) =>
            handleDeviceTypesChange(selected.map((option) => option.value as NeededDeviceType))
          }
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 10000 }),
          }}
        />
      </div>
      <OfficePreferredDmeOfficeSection officeId={officeId} />
      <OfficeFollowUpProvidersSection officeId={officeId} />
    </div>
  )
}
